import styled from '@emotion/styled';

export const ContentWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  flex-direction: row;

  @media (max-width: 1200px) {
    flex-direction: column-reverse;
  }
`;

export const LeftPlaceholder = styled.div`
  max-width: 1200px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-right: 24px;
  padding-top: 24px;
  font-size: 18px;

  @media (min-width: 1201px) and (max-width: 1460px) {
    max-width: 850px;
  }

  @media (max-width: 1200px) {
    width: 100%;
  }
`;

export const RightPlaceholder = styled.div`
  display: flex;
  flex-direction: column;
  width: 297px;
  padding-top: 120px;
  display: flex;
  flex-direction: column;
  gap: 24px;

  @media (max-width: 1200px) {
    display: flex;
    flex-direction: column;
    padding-top: 0;
    gap: 20px;
  }
`;

export const CardsContainer = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;
  justify-items: start;
  padding-left: 0;

  @media (max-width: 1200px) {
    grid-template-columns: 1fr;
  }

  @media (max-width: 660px) {
    grid-template-columns: 1fr;
  }
`;

export const StyledCardWrapper = styled.div`
  width: 100%;
  padding: 0;
  text-align: left;

  @media (max-width: 660px) {
    width: calc(100% - 20px);
    max-height: none;
    flex-direction: column;
  }
  @media (max-width: 1680px) {
    width: 800px;
  }
  @media (max-width: 1480px) {
    width: 600px;
  }
  @media (max-width: 1300px) {
    width: 530px;
  }
  @media (max-width: 1200px) {
    width: 100%;
  }
`;

export const WelcomePlaceholder = styled.div`
  height: 40px;
  margin-bottom: 25px;

  @media (max-width: 900px) {
    height: 60px;
  }
`;

export const DetailViewWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const FadeContainer = styled.div`
  &.fade-enter {
    opacity: 0;
  }

  &.fade-enter-active {
    opacity: 1;
    transition: opacity 300ms ease-in-out;
  }

  &.fade-exit {
    opacity: 1;
  }

  &.fade-exit-active {
    opacity: 0;
    transition: opacity 300ms ease-in-out;
  }
`;
